// src/pages/Contact.jsx
import React from "react";
import ContactForm from "../components/ContactForm";

const Contact = () => {
  return (
    <div className="">
      <ContactForm />
    </div>
  );
};

export default Contact;
